"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by juniusang on 5/24/17.
 */
const dimension = __importStar(require("./dimension"));
const platform = __importStar(require("./platform"));
const Logger_1 = __importDefault(require("./Logger"));
const DRNException_1 = __importDefault(require("../exception-type/DRNException"));
const DRNUtil = {
    ...dimension,
    ...platform,
    // Logger
    log: (value, header = 'DISTRICT_JS') => {
        __DEV__ && console.log(header, JSON.stringify(value));
        Logger_1.default.log(value);
    },
    warn: (value) => {
        Logger_1.default.warn(value);
    },
    display: (value) => {
        Logger_1.default.display(value);
    },
    error: (value) => {
        Logger_1.default.error(value);
    },
    clearLog: () => {
        __DEV__ && console.clear();
        Logger_1.default.clear();
    },
    setLogger: (logger) => {
        __DEV__ && Logger_1.default.setLogger(logger);
    },
    /**
     * Only test if object empty( {} ) or not
     * for more comprehensive check, please use isObjectNotNullUndefinedEmpty
     *
     * @param {*} objToCheck must be a valid object {}
     * @returns true if empty
     */
    isObjectEmpty: (objToCheck) => {
        if (objToCheck === null) {
            throw DRNException_1.default.NullPointerException(objToCheck, '[DRNUtil.isObjectEmpty] objToCheck cannot null');
        }
        if (objToCheck !== Object(objToCheck)) {
            throw DRNException_1.default.NotAnObjectException(objToCheck, '[DRNUtil.isObjectEmpty] objToCheck is not an object');
        }
        return Object.keys(objToCheck).length === 0 && objToCheck.constructor === Object;
    },
    /**
     * handle string checking, and common object checking
     * Will safely return false if parameter provided is not an Object
     * @param {*} objToCheck if String, it will check if string empty or not, if common Object will check the content to be not null & not undefined & not empty
     * @returns true if object is strictly correct in form.
     */
    isObjectNotNullUndefinedEmpty: (objToCheck) => {
        const result = objToCheck !== null && objToCheck !== undefined;
        // check if object is primitive numeric value
        if (result && !isNaN(objToCheck)) {
            return false;
        }
        if (result && (typeof objToCheck === 'string' || objToCheck instanceof String)) {
            return objToCheck.length > 0;
        }
        if (result) {
            return !(Object.keys(objToCheck).length === 0 && objToCheck.constructor === Object);
        }
        return false;
    },
};
exports.default = DRNUtil;
